export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;

export const LOGIN_URL = BASE_URL + "/auth/login";
export const ME_URL = BASE_URL + "/auth/me";
export const USER_URL = BASE_URL + "/user";
export const CLIENT_URL = BASE_URL + "/client";
export const MODULE_URL = BASE_URL + "/module";
export const VERSION_URL = BASE_URL + "/version";
export const INVOICE_URL = BASE_URL + "/invoice";
export const EMAIL_LIST_URL = BASE_URL + "/email-lists";
export const EMAIL_TEMPLATES_URL = BASE_URL + "/email-templates";
export const OFFER_URL = BASE_URL + "/offer";
